<template>
    <div>
        <Modal ref="modal" v-model="modalOpen">
            <div class="info-box-modal-content disable-info-icon flashcards">
                <div class="close-button" data-close />
                <h3 class="title">
                    {{ modalContent.title }}
                </h3>
                <div class="flex">
                    <div class="image-wrapper">
                        <div class="border" />
                        <img class="image" :src="modalContent.image">
                    </div>
                    <ul class="flashcard-entries big">
                        <li
                            v-for="(entry) in modalContent.entries" :key="entry.title"
                            class="entry"
                        >
                            {{ entry }}
                        </li>
                    </ul>
                </div>
            </div>
        </Modal>

        <transition-group
            appear
            :css="false"
            name="list"
            tag="ul"
            class="flashcards-wrapper styleless"
            @enter="zoomIn"
        >
            <li
                v-for="(card, index) in cards" :key="card.title"
                class="flashcard"
                @click="openModal(index)"
            >
                <div
                    ref="border"
                    class="border"
                />
                <div ref="content" class="content">
                    <div class="image-wrapper">
                        <img class="image" :src="card.image">
                        <transition name="fade" appear>
                            <div v-if="visitedCards.includes(index)" class="image-title">
                                {{ card.title }}
                            </div>
                        </transition>
                    </div>
                </div>
            </li>
        </transition-group>
    </div>
</template>

<script>
import gsap from 'gsap';
import SlideState from '@/mixins/SlideState';

export default {
    name: 'FlashCards',
    mixins: [SlideState],
    props: {
        cards: {
            type: Array,
            required: true
        }
    },
    data: () => (
        {
            visitedCards: [],
            cardIndex: 0,
            modalOpen: false
        }),
    computed: {
        modalContent()
        {
            return this.cards[this.cardIndex];
        }
    },
    mounted()
    {
        const state = this.getState();
        this.visitedCards = state ?? [];

        if (this.visitedCards.length === this.cards.length)
        {
            this.$parent.setNextButtonActive(true);
        }
    },
    methods: {
        openModal(index)
        {
            this.cardIndex = index;
            this.modalOpen = true;

            if (this.visitedCards.indexOf(index) === -1)
            {
                this.visitedCards.push(index);
            }

            this.saveState(this.visitedCards);

            if (this.visitedCards.length === this.cards.length)
            {
                this.$parent.setNextButtonActive(true);
            }
        },
        zoomIn(el, done)
        {
            const {$refs} = this;
            gsap.timeline({onComplete: done})
                .fromTo(
                    $refs.border,
                    {scale: 0.5, opacity: 0},
                    {duration: 1, scale: 1, opacity: 1, ease: 'elastic.out(1.1, 1)', force3D: false}
                )
                .fromTo(
                    $refs.content,
                    {scale: 0.5, opacity: 0},
                    {duration: 1.2, scale: 1, opacity: 1, ease: 'elastic.out(1.1, 0.9)'},
                    0.1
                )
                .set([$refs.border, $refs.content], {clearProps: 'all'});
        }
    }
};
</script>

<style lang="scss" src="./FlashCards.scss" />

